<template>
    <div>
        <section>
            <div class="inner row5">
                <div class="title">
                    <h1>제품 관리</h1>
                </div>
                <section>
                    <div class="row4">
                        <article class="flex flexAlignS productStep1">
                            <div class="left">
                                <div class="title">
                                    <h5>산업부문(1차)<span class="txtRed">*</span></h5>
                                </div>
                                <div class="content">
                                    <table>
                                        <tbody>
                                            <tr>
                                                <th>
                                                    <input type="radio" id="radioItem1" name="industrySort">
                                                </th>
                                                <td>
                                                    <label for="radioItem1">고령친화의약품산업</label>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <input type="radio" id="radioItem2" name="industrySort">
                                                </th>
                                                <td>
                                                    <label for="radioItem2">고령친화식품산업</label>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <input type="radio" id="radioItem3" name="industrySort">
                                                </th>
                                                <td>
                                                    <label for="radioItem3">고령친화용품산업</label>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <input type="radio" id="radioItem4" name="industrySort">
                                                </th>
                                                <td>
                                                    <label for="radioItem4">고령친화화장품산업</label>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <input type="radio" id="radioItem5" name="industrySort">
                                                </th>
                                                <td>
                                                    <label for="radioItem5">고령친화의료기기산업</label>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <input type="radio" id="radioItem6" name="industrySort">
                                                </th>
                                                <td>
                                                    <label for="radioItem6">이동·교통산업</label>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <input type="radio" id="radioItem7" name="industrySort">
                                                </th>
                                                <td>
                                                    <label for="radioItem7">건강노화힐링산업</label>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <input type="radio" id="radioItem8" name="industrySort">
                                                </th>
                                                <td>
                                                    <label for="radioItem8">건강노화힐링산업</label>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div class="right">
                                <div class="title">
                                    <h5>대분류(2차)<span class="txtRed">*</span></h5>
                                </div>
                                <div class="content">
                                    <table>
                                        <tbody>
                                            <tr>
                                                <th>
                                                    <input type="checkbox" id="checkItem1" name="largeCategory">
                                                </th>
                                                <td>
                                                    <label for="checkItem1">고령친화식품(특수의료용도식품, 전통발효식품 등)</label>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <input type="checkbox" id="checkItem2" name="largeCategory">
                                                </th>
                                                <td>
                                                    <label for="checkItem2">건강기능식품(영양과 식이요법을 위한 식품)</label>
                                                </td>
                                            </tr>
                                            
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </article>

                        <article class="productStep2">
                            <div class="title">
                                <h5>대분류(2차)<span class="txtRed">*</span></h5>
                            </div>
                            <div class="tableContainer">
                                <div class="sampleTemplate">
                                    <b-table
                                    id="table"
                                    :fields="fields"
                                    :items="items"
                                    :per-page="perPage"
                                    :current-page="currentPage"
                                    @head-clicked="onHeadClicked"
                                    @row-clicked="onRowClicked"
                                    :sort-by.sync="sortBy"
                                    :sort-desc.sync="sortDesc"
                                    :select-mode="selectMode"
                                    selectable
                                    @row-selected="onRowSelected"
                                    hover
                                    >
                                        <template #cell(STATUS)="data">
                                            <span v-html="data.value"></span>
                                        </template>
                                        <template #cell(selected)="{ rowSelected }">
                                            <template v-if="rowSelected">
                                                <span aria-hidden="true">&check;</span>
                                                <span class="sr-only">Selected</span>
                                            </template>
                                            <template v-else>
                                                <span aria-hidden="true">&nbsp;</span>
                                                <span class="sr-only">Not selected</span>
                                            </template>
                                        </template>
                                    </b-table>
                                </div>
                            </div>
                        </article>

                        <article class="productStep3">
                            <div class="container">
                                <div class="enrollItem">
                                    <div class="title">
                                        <h5>제조구분<span class="txtRed">*</span></h5>
                                    </div>
                                    <div class="productInputBox">
                                        <div class="radioContentBox">
                                            <div class="radioItem">
                                                <input type="radio" id="placeSelector1" name="placeSelector" checked>
                                                <label for="placeSelector1">국내</label>
                                            </div>
                                            <div class="radioItem">
                                                <input type="radio" id="placeSelector2" name="placeSelector">
                                                <label for="placeSelector2">해외</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="enrollItem">
                                    <div class="title">
                                        <h5>이미지 등록<span class="txtRed">*</span></h5>
                                    </div>
                                    <div class="productInputBox">
                                        <div class="fileUpLoadBox">
                                            <input type="text" class="fileUploadName" value="파일선택" disabled>
                                            <!-- <input type="file" id="fileUpload"> -->
                                            <label for="fileUpload" class="fileUploadBtn" @click="fileUploadBtn()">업로드</label>
                                            <ModalFileUpload v-if="isShowModalFileUpload" @modal-closed='handleModalClosed'/>
                                        </div>
                                    </div>
                                </div>
                                <div class="enrollItem">
                                    <div class="title">
                                        <h5>제품명<span class="txtRed">*</span></h5>
                                    </div>
                                    <div class="productInputBox">
                                        <input type="text" name="" id="">
                                    </div>
                                </div>
                                <div class="enrollItem">
                                    <div class="title">
                                        <h5>업체명<span class="txtRed">*</span></h5>
                                    </div>
                                    <div class="productInputBox">
                                        <input type="text" name="" id="">
                                    </div>
                                </div>
                                <div class="enrollItem">
                                    <div class="title">
                                        <h5>가격<span class="txtRed">*</span></h5>
                                    </div>
                                    <div class="productInputBox">
                                        <input type="text" name="" id="">
                                    </div>
                                </div>
                                <div class="enrollItem">
                                    <div class="title">
                                        <h5>홈페이지</h5>
                                    </div>
                                    <div class="productInputBox">
                                        <input type="text" name="" id="">
                                    </div>
                                </div>
                            </div>
                        </article>

                        <article class="productStep4">
                            <div class="container">
                                <div class="explainBox">
                                    <div class="title">
                                        <h5>
                                            제품 설명<span class="txtRed">*</span>
                                        </h5>
                                    </div>
                                    <div class="textAreaBox">
                                        <textarea name="" id=""></textarea>
                                    </div>
                                </div>

                                <div class="editBox">
                                    <div class="title">
                                        <h5>
                                            상세 설명<span class="txtRed">*</span>
                                        </h5>
                                    </div>
                                    <div class="editArea">

                                    </div>
                                </div>
                            </div>
                        </article>

                        <div class="botArea">
                            <button class="enrollBtn">등 록</button>
                        </div>
                    </div>
                </section>
            </div>
        </section>
    </div>   
</template>

<script>
import ModalFileUpload from '@/components/managementPopup/ModalFileUpload'

export default {
    name: 'ProductManagementDetail',
    components: {
        ModalFileUpload
    },
    data() {
        return {
            isShowModalFileUpload: false,
            totalNo: 1,
            nowPage: 1,
            totalPage: 2,
            perPage: 4,
            currentPage: 1,
            totalCnt: 0,
            // sample items
            items: [
                {
                    ID: '1',
                    STATUS: '실내',
                    PLACE: '주방',
                    INDUSTRYSORT: '고령친화식품산업',
                    LARGECATEGORY: '고령친화식품(특수의료용도식품, 전통발효식품 등)',
                    isActive: true
                },
                {
                    ID: '2',
                    STATUS: '실내',
                    PLACE: '주방',
                    INDUSTRYSORT: '고령친화식품산업',
                    LARGECATEGORY: '건강기능식품(영양과 식이요법을 위한 식품)',
                },
                {
                    ID: '3',
                    STATUS: '실외',
                    PLACE: '지역사회 내 이동(시장, 병원 등)',
                    INDUSTRYSORT: '고령친화식품산업',
                    LARGECATEGORY: '고령친화식품(특수의료용도식품, 전통발효식품 등)',
                }
            ],
            //sortBy: 최초 보이는 화면의 sort 기준, sortDesc 순서
            sortBy: 'ID',
            sortDesc: false,
            selectMode: 'single',
            selected: [],
            fields: [
                {
                    key: 'selected',
                    label: '선택',
                    class: 'text-center',
                },
                {
                    key: 'ID',
                    label: 'No',
                    sortable: false,
                    sortDirection: 'desc',
                    class: 'text-center'
                },
                {
                    key: 'STATUS',
                    label: '실내·외',
                    sortable: false,
                    isActive: true,
                    class: 'statusOn text-center',
                },
                {
                    key: 'PLACE',
                    label: '장소',
                    sortable: false,
                    class: 'text-center'
                },
                {
                    key: 'INDUSTRYSORT',
                    label: '산업분류(1차)',
                    sortable: false,
                    class: 'text-center'
                },
                {
                    key: 'LARGECATEGORY',
                    label: '대분류(2차)',
                    sortable: false,
                    class: 'text-center'
                }
            ]
        }
    },
    methods:{
        onRowSelected(items) {
            this.selected = items
        },
        onHeadClicked(/*selected*/) {
            this.$refs.table.selectAllRows()
        },
        goback(){
            this.$router.go(-1) 
        },
        writeBtn() {
            this.$router.push('/admin/noticeManagementWrite');
        },
        handleModalClosed(value){
			if(value === ModalFileUpload.name){
				this.isShowModalFileUpload = false
			}
		},
        fileUploadBtn() {
            this.isShowModalFileUpload = true
        }
    }
}
</script>

<style scoped lang="scss">
    .sampleTemplate ::v-deep {
        @import "~bootstrap/dist/css/bootstrap.min";
    }
</style>